import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import withUser from './containers/withUser';
import { canEnter, accessRedirect } from './utils/access';

class ProtectedRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: null,
      isLoading: true,
      allowed: null,
      redirectTo: null,
    };
  }

  async componentDidMount() {
    const { user, validateUserToken } = this.props;

    const response = await validateUserToken(user);

    if (response) {
      // ⚠️ On relit `this.props.user`, et non le `user` d'entrée : la validation vient de
      // rafraîchir la charge dans le magasin, et c'est cette version-là qui porte l'état
      // à jour.
      //
      // La décision arrive TOUTE FAITE du serveur. Elle était recomposée ici, à partir de
      // trois booléens et d'une comparaison de dates en JavaScript : un membre d'équipe
      // était renvoyé vers /subscribe au bout de quinze jours pendant que son employeur
      // payait, et l'écran de renouvellement pouvait le renvoyer ici en boucle.
      const fresh = this.props.user;

      this.setState({
        isAuthenticated: true,
        isLoading: false,
        allowed: canEnter(fresh),
        redirectTo: accessRedirect(fresh),
      });
    } else {
      this.setState({ isAuthenticated: false, isLoading: false });
    }
  }

  render() {
    const { component: Component, ...rest } = this.props;
    const {
      isLoading, isAuthenticated, allowed, redirectTo,
    } = this.state;

    if (isLoading) {
      return null;
    }

    return (
      <div>
        <Route
          {...rest}
          render={(props) => {
            if (!isAuthenticated) return <Redirect to="/login" />;
            if (allowed) return <Component {...props} />;
            // Sans destination connue, on laisse entrer plutôt que de tourner en rond :
            // rediriger vers une page qui renvoie ici est une boucle, et l'application
            // devient inutilisable. Le serveur, lui, refuse chaque appel de toute façon.
            return redirectTo ? <Redirect to={redirectTo} /> : <Component {...props} />;
          }}
        />
      </div>
    );
  }
}

export default withUser(ProtectedRoute);
